import api from './api';
import { toast } from 'sonner';
import { feedback } from './feedback';

const QUEUE_KEY = 'sisp_sync_queue';

function registerBackgroundSync() {
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    navigator.serviceWorker.ready
      .then((reg) => reg.sync.register('sisp-sync-queue'))
      .catch(() => { /* no soportado en este navegador, se sincroniza por evento online igual */ });
  }
}

export const syncManager = {
  getQueue: () => {
    try {
      return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
    } catch {
      return [];
    }
  },

  saveQueue: (queue) => {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  },

  addToQueue: (url, method, data, label) => {
    const queue = syncManager.getQueue();
    queue.push({
      id: Date.now(),
      url,
      method,
      data,
      label,
      timestamp: new Date().toISOString()
    });
    syncManager.saveQueue(queue);
    toast.info(`Guardado localmente: ${label}. Se sincronizará al recuperar internet.`);
    feedback.queued();
    registerBackgroundSync();
  },

  sync: async () => {
    if (!navigator.onLine) return;

    const queue = syncManager.getQueue();
    if (queue.length === 0) return;

    console.log(`Iniciando sincronización de ${queue.length} elementos...`);
    const remainingQueue = [];

    for (const item of queue) {
      try {
        await api({
          url: item.url,
          method: item.method,
          data: item.data
        });
        toast.success(`Sincronizado: ${item.label}`);
        feedback.success();
      } catch (error) {
        console.error(`Error sincronizando ${item.label}:`, error);
        remainingQueue.push(item);
      }
    }

    syncManager.saveQueue(remainingQueue);
  },

  isOffline: () => !navigator.onLine
};

// Escuchar cambios de conexión
window.addEventListener('online', () => {
  syncManager.sync();
});

// El Service Worker puede pedirnos sincronizar en segundo plano (Background Sync API)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'sisp-run-sync') {
      syncManager.sync();
    }
  });
}
